import { useCallback } from "react";

/**
 * Hook personnalisé pour formater une date en "YYYY-MM-DD".
 * @returns {function(string): string} Une fonction qui prend une date et retourne la date formatée.
 */
const useDateFormatter = () => {
    /**
     * Formate une date en "YYYY-MM-DD".
     * @param {string} dateString - La chaîne de date à formater.
     * @returns {string} La date formatée en "YYYY-MM-DD".
     */
    const formatDate = useCallback((dateString) => {
        if (!dateString) return ""; // Vérifie si la date est invalide ou inexistante
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return ""; // Vérifie si la date est invalide
        return date.toISOString().split("T")[0]; // Extraire uniquement la partie "YYYY-MM-DD"
    }, []);

    return formatDate;
};

export default useDateFormatter;